package site.shadadman.pages.worklog.SportsGameX

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initApr92025SportsGamexFirstSprintPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("worklog/SportsGameX/apr92025SportsGamexFirstSprint.md", FrontMatterElement.EmptyMap))
}

@Page("/worklog/SportsGameX/apr92025-sports-gamex-first-sprint")
@Composable
fun Apr92025SportsGamexFirstSprintPage() {
    org.jetbrains.compose.web.dom.H2(attrs = { id("apr-9-2025-sportsgamex-first-sprint") }) {
        org.jetbrains.compose.web.dom.Text("apr-9-2025-SportsGamex-First-Sprint")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("I have to admit, the first spring was amazing, but in all of my jobs, the first spring has always been exciting and new.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The idea behind the software was great, a platform to bet on sports and athletes, with the ability to create fantasy teams and bet on specific live plays.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("At the time i join the team, the software was in a high stage of deployments. Android and iOS team was collaborating alongside each other long before i join them. Almost the main section of the app was complete, at the time they wore working on Fantasy section.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("In the first few hours of getting my hands on the Android code, I had already figured out almost everything. The structure of the source code was new to me, but it was well architected for scalability and a large team. When I look at the code, there’s no need for extra words or documentations, I understand what’s going on just by reading it.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The project was using MVI for data floating and clean arch for business logic. What makes the project more interesting was the folder structure. We had 3 main modules called ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("shared")
        }
        org.jetbrains.compose.web.dom.Text(", ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("common")
        }
        org.jetbrains.compose.web.dom.Text(" and ")
        org.jetbrains.compose.web.dom.Code {
            org.jetbrains.compose.web.dom.Text("config")
        }
        org.jetbrains.compose.web.dom.Text(".")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Code {
                    org.jetbrains.compose.web.dom.Text("shared")
                }
                org.jetbrains.compose.web.dom.Text(" was responsible for holding shared content such as splash, settings and main components like navigation tabs, deep links management and notification states like their screen destination.")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Code {
                    org.jetbrains.compose.web.dom.Text("common")
                }
                org.jetbrains.compose.web.dom.Text(" was the main module holding both logic and views containing 3 submodules:")
            }
            org.jetbrains.compose.web.dom.Ul {
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.Code {
                        org.jetbrains.compose.web.dom.Text("base")
                    }
                    org.jetbrains.compose.web.dom.Text(" containing the overall structure like models, navigation graphs, resources and theme")
                }
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.Code {
                        org.jetbrains.compose.web.dom.Text("feature")
                    }
                    org.jetbrains.compose.web.dom.Text(" contained submodules for our features like onboarding, main and fantasy")
                }
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.Code {
                        org.jetbrains.compose.web.dom.Text("network")
                    }
                    org.jetbrains.compose.web.dom.Text(" for Ktor configuration")
                }
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.Code {
                        org.jetbrains.compose.web.dom.Text("storage")
                    }
                    org.jetbrains.compose.web.dom.Text(" for local preferences and database")
                }
            }
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.P {
                org.jetbrains.compose.web.dom.Code {
                    org.jetbrains.compose.web.dom.Text("config")
                }
                org.jetbrains.compose.web.dom.Text(" responsible for holding different configs for release, debug and staging such as current currency and api urls.")
            }
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The first spring ended with me familiarizing myself with my team, the designs, the feature goals, and the project structure. I’d also like to mention that the designs were stunning and eye catching, especially in the fantasy section. I have high hopes for this platform.")
    }
}
